import React from "react";
import { Link } from "react-router-dom";
import { Paper, BottomNavigation, BottomNavigationAction, Badge, Avatar } from "@mui/material";
import {
    HomeOutlined,
    PeopleOutline,
    Notifications as NotificationsIcon,
    AccountCircle,
    MessageOutlined,
    Event as EventIcon,
    Menu as MenuIcon,
} from "@mui/icons-material";

interface User {
    id?: string;
    firstName?: string | null;
    // Add other user properties if needed by the component, though only firstName is used here
}

interface MobileNavbarProps {
    isAuthenticated: boolean;
    isTabletUp: boolean;
    bottomNavClassName: string;
    navActionClassName: string;
    themeMode: "light" | "dark";
    value: number;
    handleChange: (event: React.SyntheticEvent, newValue: number) => void;
    unreadOtherCount: number;
    profilePhoto?: string | null;
    user?: User | null;
    handleMobileProfileClick: (event: React.MouseEvent<HTMLElement>) => void;
}

const MobileNavbar: React.FC<MobileNavbarProps> = ({
    isAuthenticated,
    isTabletUp,
    bottomNavClassName,
    navActionClassName,
    themeMode,
    value,
    handleChange,
    unreadOtherCount,
    profilePhoto,
    user,
    handleMobileProfileClick,
}) => {
    if (isTabletUp || !isAuthenticated) {
        return null;
    }

    return (
        <Paper
            elevation={0}
            className={bottomNavClassName}
            sx={{
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1050,
                backgroundColor:
                    themeMode === "dark"
                        ? "rgba(20, 20, 20, 0.65) !important"
                        : "rgba(255, 255, 255, 0.75) !important",
                backdropFilter: "blur(8px)",
                WebkitBackdropFilter: "blur(8px)",
                boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.08)",
            }}
        >
            <BottomNavigation
                value={value}
                onChange={handleChange}
                showLabels
                sx={{ backgroundColor: "transparent" }}
            >
                {/* <BottomNavigationAction
                    key="events"
                    label="Events"
                    icon={<EventIcon />}
                    component={Link}
                    to="/events"
                    className={navActionClassName}
                /> */}
                <BottomNavigationAction
                    key="newsfeed"
                    label="Home"
                    icon={<HomeOutlined />}
                    component={Link}
                    to="/newsfeed"
                    className={navActionClassName}
                />
                <BottomNavigationAction
                    key="messaging"
                    label="Messaging"
                    icon={<MessageOutlined />}
                    component={Link}
                    to="/messaging"
                    className={navActionClassName}
                />
                <BottomNavigationAction
                    key="people"
                    label="People"
                    icon={<PeopleOutline />}
                    component={Link}
                    to="/people"
                    className={navActionClassName}
                />
                <BottomNavigationAction
                    key="notifications"
                    label="Notifications"
                    icon={
                        <Badge
                            badgeContent={unreadOtherCount}
                            color="error"
                            invisible={unreadOtherCount === 0}
                        >
                            <NotificationsIcon />
                        </Badge>
                    }
                    component={Link}
                    to="/notifications"
                    className={navActionClassName}
                />
                <BottomNavigationAction
                    key="profile"
                    label="Menu"
                    icon={<MenuIcon />}
                    onClick={handleMobileProfileClick}
                    className={navActionClassName}
                />
            </BottomNavigation>
        </Paper>
    );
};

export default MobileNavbar;
